// utils/jgRingtoneEngine.js
// ------------------------------------------------------------------------------------
// JG Universe FAANG++ Ringtone Engine
// Centralized audio engine for incoming ring, outgoing ring, and hangup sound.
// Fully compatible with CallContext.js (playRingtone/stopRingtone).
// Uses the URLs you confirmed from master (no regressions).
// ------------------------------------------------------------------------------------

console.log('[JG Ringtone Engine] loaded');

// 🔊 Correct audio assets from master
const INCOMING_RING_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1756098711/Drinkin_The_Night_Away_-_Instrumental_MASTERED_DK_xpfhks.mp3';

const OUTGOING_RING_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1756098711/Drinkin_The_Night_Away_-_Instrumental_MASTERED_DK_xpfhks.mp3';

const HANGUP_SOUND_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/v1756187929/Instagram_end_call_sound_sffect_no-copyright_zqpcis.mp3';

// How long each ring slice is (used for loop trimming)
const RING_SEGMENT_SECONDS = 5;

// For "call unanswered" and "call declined"
export const CALL_RING_TIMEOUT_MS = 30000;

// Internal AudioBuffers
let incomingBuffer = null;
let outgoingBuffer = null;
let hangupBuffer = null;

// Active playback nodes so we can stop cleanly
let audioCtx = null;
let activeSource = null;
let ringType = null;

// Lazy-load and decode audio once
async function loadAudio(url) {
  if (!audioCtx)
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  const res = await fetch(url);
  const arr = await res.arrayBuffer();
  return await audioCtx.decodeAudioData(arr);
}

// 🔁 Start looping ring (incoming or outgoing)
function playLoop(buffer) {
  stopRingtone();

  if (!audioCtx)
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  const src = audioCtx.createBufferSource();
  src.buffer = buffer;
  src.loop = true;

  const gainNode = audioCtx.createGain();
  gainNode.gain.value = 0.35; // subtle volume

  src.connect(gainNode).connect(audioCtx.destination);
  src.start(0);

  activeSource = src;
}

// 🔔 Public API: Start ringtone
// type = 'incoming' | 'outgoing'
export async function playRingtone(type = 'incoming') {
  try {
    ringType = type;

    if (type === 'incoming') {
      if (!incomingBuffer) incomingBuffer = await loadAudio(INCOMING_RING_URL);
      playLoop(incomingBuffer);
    } else {
      if (!outgoingBuffer) outgoingBuffer = await loadAudio(OUTGOING_RING_URL);
      playLoop(outgoingBuffer);
    }
  } catch (err) {
    console.warn('[JG Ringtone Engine] play error:', err);
  }
}

// 🛑 Public API: Stop ringtone
export function stopRingtone() {
  try {
    if (activeSource) {
      activeSource.stop(0);
      activeSource.disconnect();
      activeSource = null;
    }
  } catch (err) {
    console.warn('[JG Ringtone Engine] stop error:', err);
  }
}

// 🔕 Play final hangup sound once
export async function playHangupSound() {
  try {
    if (!audioCtx)
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (!hangupBuffer) hangupBuffer = await loadAudio(HANGUP_SOUND_URL);

    const src = audioCtx.createBufferSource();
    src.buffer = hangupBuffer;

    const gainNode = audioCtx.createGain();
    gainNode.gain.value = 0.6;

    src.connect(gainNode).connect(audioCtx.destination);
    src.start(0);
  } catch (err) {
    console.warn('[JG Hangup] error:', err);
  }
}
